__turbopack_context__.v({
  "accordionSlideOverwrite": "navigationMenu-module-scss-module__oypuIq__accordionSlideOverwrite",
  "fadeIn": "navigationMenu-module-scss-module__oypuIq__fadeIn",
  "fadeOut": "navigationMenu-module-scss-module__oypuIq__fadeOut",
  "link": "navigationMenu-module-scss-module__oypuIq__link",
  "linkHover": "navigationMenu-module-scss-module__oypuIq__linkHover",
  "navigationMenu": "navigationMenu-module-scss-module__oypuIq__navigationMenu",
  "scaleIn": "navigationMenu-module-scss-module__oypuIq__scaleIn",
  "scaleOut": "navigationMenu-module-scss-module__oypuIq__scaleOut",
  "zoomIn": "navigationMenu-module-scss-module__oypuIq__zoomIn",
  "zoomOut": "navigationMenu-module-scss-module__oypuIq__zoomOut",
});
